import axios from 'axios'
import { api } from '@/services/config'
import store from '@/store'
import { mixin } from '@/mixins/helper'

const editStore = {
  namespaced: true,
  state: () => ({
    isEditInfo: false,
    legalDocDetail: {},
    sioDetail: {},
    k3lDetail: {},
    kplhDetail: {},
    legalDocName: '',

    isLegaldocEdit: false,
    isLegalDocAvailable: true,
    isSioEdit: false,
    isKplhEdit: false,
    isK3lEdit: false,
  }),
  mutations: {
    SET_EDIT_INFO(state) {
      state.isEditInfo = !state.isEditInfo
    },
    CLOSE_EDIT_INFO(state) {
      state.isEditInfo = false
    },
    SET_DATA(state, payload) {
      state[payload.name] = payload.value
    },
    SET_OBJECT(state, payload) {
      state[payload.state][payload.key] = payload.value
    },
  },
  actions: {
    async getLegalDocById({ commit }, payload) {
      const url = `${api}/api/v1/d-vendor-legal-document/${payload.id}`

      commit('SET_GLOBAL_LOADING', false, { root: true })
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        commit('SET_DATA', { name: 'legalDocDetail', value: data.data })
        commit('SET_DATA', {
          name: 'legalDocName',
          value: payload && payload.name,
        })
        commit('SET_GLOBAL_LOADING', false, { root: true })
      } catch (error) {
        commit('SET_GLOBAL_LOADING', false, { root: true })
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async createLegalDoc({ commit, state }, payload) {
      const url = `${api}/api/v1/d-vendor-legal-document`
      await commit('level1/SET_LOADING', true, { root: true })

      let bodyFormData = new FormData()
      state.legalDocDetail.tanggal_efektif &&
        bodyFormData.append(
          'tanggal_efektif',
          state.legalDocDetail.tanggal_efektif
        )
      state.legalDocDetail.tanggal_berakhir &&
        bodyFormData.append(
          'tanggal_berakhir',
          state.legalDocDetail.tanggal_berakhir
        )

      if (payload.lampiran) {
        bodyFormData.append('lampiran', payload.lampiran)
      }

      if (
        (state.legalDocDetail.no_dokumen &&
          state.legalDocDetail.no_dokumen != 'null') ||
        payload.lampiran
      ) {
        bodyFormData.append('no_dokumen', state.legalDocDetail.no_dokumen)
      }

      try {
        const { data } = await axios({
          method: 'POST',
          url,
          data: bodyFormData,
          headers: { 'Content-Type': 'multipart/form-data' },
        })

        if (data && data.status == 'success') {
          await commit('SET_NOTIF', data.message, { root: true })
          await commit('level1/SET_LOADING', false, { root: true })
          await commit('modalStore/CLOSE_LEGAL_DOC', null, { root: true })
          await commit('SET_DATA', { name: 'legalDocDetail', value: {} })
          await commit('level1/GET_LEGAL_DOC', 'legaldoc', { root: true })
        }
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('level1/SET_LOADING', false, { root: true })
      }
    },
    async updateLegalDoc({ commit, state }, payload) {
      const url = `${api}/api/v1/d-vendor-legal-document/${payload.id}`
      await commit('level1/SET_LOADING', true, { root: true })

      let bodyFormData = new FormData()
      state.legalDocDetail.tanggal_efektif &&
        bodyFormData.append(
          'tanggal_efektif',
          state.legalDocDetail.tanggal_efektif
        )
      state.legalDocDetail.tanggal_berakhir &&
        bodyFormData.append(
          'tanggal_berakhir',
          state.legalDocDetail.tanggal_berakhir
        )

      if (payload.lampiran) {
        bodyFormData.append('lampiran', payload.lampiran)
      }

      if (
        (state.legalDocDetail.no_dokumen &&
          state.legalDocDetail.no_dokumen != 'null') ||
        payload.lampiran
      ) {
        bodyFormData.append('no_dokumen', state.legalDocDetail.no_dokumen)
      }

      try {
        const { data } = await axios({
          method: 'PUT',
          url,
          data: bodyFormData,
          headers: { 'Content-Type': 'multipart/form-data' },
        })

        if (data && data.status == 'success') {
          await commit('SET_NOTIF', data.message, { root: true })
          await commit('level1/SET_LOADING', false, { root: true })
          await commit('modalStore/CLOSE_LEGAL_DOC', null, { root: true })
          await commit('SET_DATA', { name: 'legalDocDetail', value: {} })
          await commit('level1/GET_LEGAL_DOC', 'legaldoc', { root: true })
        }
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('level1/SET_LOADING', false, { root: true })
      }
    },
    async getK3lById({ commit }, payload) {
      const url = `${api}/api/v1/d-vendor-k3l/${payload.id}`

      commit('SET_GLOBAL_LOADING', false, { root: true })
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        commit('SET_DATA', { name: 'k3lDetail', value: data.data })
        commit('SET_GLOBAL_LOADING', false, { root: true })
      } catch (error) {
        commit('SET_GLOBAL_LOADING', false, { root: true })
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async AddK3lKplh({ commit, state }, payload) {
      await commit('level1/SET_LOADING', true, { root: true })
      let url = `${api}/api/v1/d-vendor-k3l`
      if (payload.name == 'kplh') {
        url = `${api}/api/v1/d-vendor-kplh`
      }

      try {
        const { data } = await axios({
          method: 'POST',
          url,
          data: {
            vendor_id: payload.id,
          },
        })

        await commit('SET_NOTIF', data.message, { root: true })
        await commit('level1/SET_LOADING', false, { root: true })
        if (payload.name == 'kplh') {
          await commit('level1/GET_KPLH_DATA', 'kplh', { root: true })
        } else {
          await commit('level1/GET_K3L_DATA', 'k3l', { root: true })
        }
      } catch (error) {
        commit('SET_GLOBAL_LOADING', false, { root: true })
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async updateK3l({ commit, state }, payload) {
      const url = `${api}/api/v1/d-vendor-k3l/${payload.id}`
      await commit('level1/SET_LOADING', true, { root: true })

      let bodyFormData = new FormData()
      payload.vendor_id && bodyFormData.append('vendor_id', payload.vendor_id)
      payload.tanggal_efektif &&
        bodyFormData.append('tanggal_efektif', payload.tanggal_efektif)
      payload.tanggal_berakhir &&
        bodyFormData.append('tanggal_berakhir', payload.tanggal_berakhir)
      payload.nilai && bodyFormData.append('nilai', payload.nilai)
      payload.keterangan &&
        bodyFormData.append('keterangan', payload.keterangan)
      payload.pic && bodyFormData.append('pic', payload.pic)
      payload.last_reviewer &&
        bodyFormData.append('last_reviewer', payload.last_reviewer)
      payload.attachment &&
        bodyFormData.append('attachment', payload.attachment)

      // let updatedData = {
      //   nilai: payload.nilai,
      //   keterangan: payload.keterangan,
      //   pic: payload.pic,
      //   last_reviewer: payload.last_reviewer,
      // }

      // if (payload.tanggal_efektif) {
      //   updatedData['tanggal_efektif'] = payload.tanggal_efektif
      // }

      // if (payload.tanggal_berakhir) {
      //   updatedData['tanggal_berakhir'] = payload.tanggal_berakhir
      // }

      try {
        const { data } = await axios({
          method: 'PUT',
          url,
          data: bodyFormData,
          headers: { 'Content-Type': 'multipart/form-data' },
        })

        await commit('SET_NOTIF', data.message, { root: true })
        await commit('level1/SET_LOADING', false, { root: true })
        await commit('level1/GET_K3L_DATA', 'k3l', { root: true })
        await commit('modalStore/CLOSE_K3L', null, { root: true })
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('level1/SET_LOADING', false, { root: true })
      }
    },
    async getKplhById({ commit }, payload) {
      const url = `${api}/api/v1/d-vendor-kplh/${payload.id}`

      commit('SET_GLOBAL_LOADING', false, { root: true })
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        commit('SET_DATA', { name: 'kplhDetail', value: data.data })
        commit('SET_GLOBAL_LOADING', false, { root: true })
      } catch (error) {
        commit('SET_GLOBAL_LOADING', false, { root: true })
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async updateKplh({ commit, state }, payload) {
      const url = `${api}/api/v1/d-vendor-kplh/${payload.id}`
      await commit('level1/SET_LOADING', true, { root: true })

      let bodyFormData = new FormData()
      payload.vendor_id && bodyFormData.append('vendor_id', payload.vendor_id)
      payload.tanggal_efektif &&
        bodyFormData.append('tanggal_efektif', payload.tanggal_efektif)
      payload.tanggal_berakhir &&
        bodyFormData.append('tanggal_berakhir', payload.tanggal_berakhir)
      payload.nilai && bodyFormData.append('nilai', payload.nilai)
      payload.keterangan &&
        bodyFormData.append('keterangan', payload.keterangan)
      payload.pic && bodyFormData.append('pic', payload.pic)
      payload.last_reviewer &&
        bodyFormData.append('last_reviewer', payload.last_reviewer)
      payload.attachment &&
        bodyFormData.append('attachment', payload.attachment)

      // let updatedData = {
      //   nilai: payload.nilai,
      //   keterangan: payload.keterangan,
      //   pic: payload.pic,
      //   last_reviewer: payload.last_reviewer,
      // }

      // if (payload.tanggal_efektif) {
      //   updatedData['tanggal_efektif'] = payload.tanggal_efektif
      // }

      // if (payload.tanggal_berakhir) {
      //   updatedData['tanggal_berakhir'] = payload.tanggal_berakhir
      // }

      try {
        const { data } = await axios({
          method: 'PUT',
          url,
          data: bodyFormData,
          headers: { 'Content-Type': 'multipart/form-data' },
        })

        await commit('SET_NOTIF', data.message, { root: true })
        await commit('level1/SET_LOADING', false, { root: true })
        await commit('level1/GET_KPLH_DATA', 'kplh', { root: true })
        await commit('modalStore/CLOSE_KPLH', null, { root: true })
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('level1/SET_LOADING', false, { root: true })
      }
    },
    async updateSio({ commit, state }, payload) {
      const url = `${api}/api/v1/d-vendor-sio`

      await commit('level1/SET_LOADING', true, { root: true })
      try {
        const { data } = await axios({
          method: 'POST',
          url,
          data: payload,
        })

        await commit('SET_NOTIF', data.message, { root: true })
        await commit('level1/SET_LOADING', false, { root: true })
        await commit('level1/GET_SIO_DATA', 'sio', { root: true })
        await commit('modalStore/CLOSE_SIO', null, { root: true })
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('level1/SET_LOADING', false, { root: true })
      }
    },
  },
}

export default editStore
